<div [@routerTransition]>
    <sub-header [title]="this.headerText + ' ' + ('Details' | localize)"
                [breadcrumbs]="breadcrumbs"></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row mt-3">
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="salesNotes_PDate">{{ l('PDate') }}</label>

                            <abp-datetime-picker #salesNotes_date="ngModel" [(ngModel)]="salesNotes.transactionDate"
                                                 id="salesNotes_date" name="salesNotes_date"
                                                 [bsConfig]="{ adaptivePosition: true }"></abp-datetime-picker>

                            <validation-messages [formCtrl]="salesNotes_date"></validation-messages>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="VendorDisplayProperty">{{ l('Customer') }}</label>
                            <app-search-customer (customerEvent)="getCustomer($event)" [customerSelectedItem]="this.customerSelectedItem"> </app-search-customer>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="PurchaseNotes_Description">{{ l('ReferenceNo') }}</label>
                            <input type="text" #salesNotes_ReferenceNo="ngModel" id="salesNotes_ReferenceNo"
                                   class="form-control" [(ngModel)]="salesNotes.referenceNo" name="ReferenceNo" />
                        </div>
                    </div>
                   
                    <div class="col-md-2" *ngIf="this.type == 3">
                        <div class="form-group">
                            <label for="PurchaseNotes_PayTo">{{ l('ReceivedFrom') }}</label>
                            <input type="text" #salesNotes_PayTo="ngModel" id="salesNotes_PayTo"
                                   class="form-control" [(ngModel)]="salesNotes.receivedFrom" name="PayTo" />
                        </div>
                    </div>
                    <div class="col-md-2" *ngIf="this.type == 3">
                        <div class="form-group">
                            <label for="salesNotes_Description">{{ l('PayBy') }}</label>
                            <select id="das" [(ngModel)]="salesNotes.accountId"
                                    class="form-select">
                                <option value="null">{{ l('SelectAccount') }}</option>
                                <option *ngFor="let item of bankAccounts" value="{{ item.id }}">
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2" *ngIf="this.type == 3">
                        <div class="form-group">
                            <label for="PurchaseNotes_ChequeNo">{{ l('ChequeNo') }}</label>
                            <input type="text" #salesNotes_PayTo="ngModel" id="salesNotes_ChequeNo"
                                   class="form-control" [(ngModel)]="salesNotes.chequeNo" name="ChequeNo" />
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="salesNotes_Description">{{ l('Description') }}</label>
                            <input type="text"
                                   id="salesNotes_Description" class="form-control"
                                   [(ngModel)]="salesNotes.description" name="Description" />

                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="5%">#</th>
                                    <th width="10%">{{ l('Code') }}</th>
                                    <th width="30%">{{ l('Account') }}</th>
                                    <th width="15%">{{ l('Description') }}</th>
                                    <th width="8%">{{ l('SubTotal') }}</th>
                                    <th width="10%">{{ l('Tax') }}</th>
                                    <th width="5%">{{ l('TaxAmount') }}</th>
                                    <th width="5%">{{ l('PNetTotal') }}</th>
                                    <th width="5%">{{ l('Action') }}</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let data of salesNotesDetails; let i = index">
                                    <td class="text-center">
                                        <div class="d-flex align-items-center">
                                            <button class="btn btn-danger d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                    style="width: 30px; height: 30px" (click)="removeItem(i)">
                                                x
                                            </button>
                                            <span class="ps-1"><b>{{ data.slNo }}</b></span>
                                        </div>
                                        <!-- (click)="removeItem(i)" -->
                                    </td>
                                    <td>
                                        <input type="text" #itemCodeInput class="form-control" [(ngModel)]="data.accountCode" (keydown.enter)="searchAccount(data.accountCode,data,i)" (blur)="searchAccount(data.accountCode,data,i)" />
                                    </td>
                                    <td>
                                        <select id="das" [(ngModel)]="data.accountId"
                                                (change)="getAccountCode($event,data,i)"
                                                class="form-select">
                                            <option value="0">{{ l('SelectAccount') }}</option>

                                            <option *ngFor="let item of allChartOfAccounts" value="{{ item.id }}">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <input #descriptionInputs (keydown.enter)="focusNext('subTotal', i)" [(ngModel)]="data.description" name="description" type="text" class="form-control" />
                                    </td>
                                    <td>
                                        <input type="text" #subTotalInput (keydown.enter)="focusNext('tax', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.subTotal" (ngModelChange)="amountCalculate(data)" />
                                    </td>
                                    <td>
                                        <select name="data.taxId" #taxInput (change)="amountCalculate(data)" (keydown.enter)="focusNext('add', i)"
                                                [(ngModel)]="data.taxId"
                                                class="form-select">
                                            <option value="null">{{ l('None') }}</option>
                                            <option *ngFor="let item of applicableTaxes" value="{{ item.id }}">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td class="text-end"><b>{{data.tax | priceFormat}}</b></td>
                                    <td class="text-end"><b>{{data.netTotal | priceFormat}}</b></td>
                                    <td width="5%" class="text-center">
                                        <button #addButton (keydown.enter)="focusNext('nextRow', i)" class="btn btn-success d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                style="width: 30px; height: 30px" (click)="addRow(i)">
                                            +
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <table>
                            <tr>
                                <td width="80%" style="vertical-align: top">
                                </td>
                                <td width="20%" style="vertical-align: top">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="PurchaseNotes_SubTotal">{{ l('PSubTotal') }}</label>
                                                <input type="number" readonly="readonly"
                                                       id="PurchaseNotes_SubTotal" class="form-control text-end"
                                                       [(ngModel)]="salesNotes.subTotal" name="SubTotal" />

                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="salesNotes_PTax">{{ l('PTax') }}</label>
                                                <input type="number"
                                                       id="salesNotes_PTax" class="form-control text-end"
                                                       [(ngModel)]="salesNotes.tax" name="PTax" readonly="readonly" />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="salesNotes_PNetTotal">{{ l('PNetTotal') }}</label>
                                                <input type="number"
                                                       id="salesNotes_PNetTotal" class="form-control text-end"
                                                       [(ngModel)]="salesNotes.netTotal" name="PNetTotal" readonly="readonly" />

                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button (click)="save(status.Draft)" class="btn btn-primary blue me-2" [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAsDraft') }}</span>
                    </button>

                    <button (click)="save(status.Invoiced)"
                            class="btn btn-primary blue float-right" [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
